import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import IQVIADT from "../IQVIADT";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen, getHeaderColNamesIQVIA } from "./../../utils";
import ProcessLoader from "../ProcessLoader";
import MultiSelectOptions from "./../MultiSelectOptions";




const NW14 = () => {

    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));

    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const allIndiaTypeDepo = depo_data.data.filter(item => item.value !== "NA"); //removed 0 from all type users

    const updatedDivData = [{ value: 0, name: "All" }];

    div_data.data.map((singleDiv, index) => {
        updatedDivData.push(singleDiv);
    });

    const today = new Date();

    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    const [SelectedDate, setSelectedDate] = useState(`${day}/${month}/${year}`);
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedDepo, setSelectedDepo] = useState(allIndiaTypeDepo[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[month_data.index - 1].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);

    const [ReportType, setReportType] = useState(1);
    const [groupLoader, setGroupLoader] = useState(true);
    const [GroupListItems, setGroupListItems] = useState([]);

    const [SelectedGroup, setSelectedGroup] = useState(0);


    const [SelectecReportType, setSelectecReportType] = useState(1);

    const [reportGenData, setreportGenData] = useState({});
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');

    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";
        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNamesIQVIA(reportGenData.data[0][key]));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = excelColorCodes;

        // reportGenData.data.slice(1).forEach(item => {
        //     const row = {
        //         backgroundColor: backgroundColors[item.color] || "", // Default to white if undefined
        //         fontColor: item.color === 2 ? "#333333" : "#333333",
        //         fontSize: 12,
        //         bold: false,
        //         values: columns.map(col => item[col])
        //     };
        //     reportJson.sheets[0].data.push(row);
        // });


        const stringColumns = ["branch", "molecule", "product", "company", "division", "compay"]; // Define the keys to keep as strings

        reportGenData.data.slice(1).forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "",
                fontColor: "#333333",
                fontSize: 12,
                bold: false,
                values: columns.map(col =>
                    stringColumns.includes(col)
                        ? item[col] // Keep as string
                        : isNaN(parseFloat(item[col])) // Check if it can be converted to a number
                            ? item[col] // If it's not numeric, keep it as is
                            : parseFloat(item[col]) // Convert to numeric if possible
                )
            };
            reportJson.sheets[0].data.push(row);

        });





        generateExcel(reportJson).catch(console.error);

    }

    const handleGroupChange = (selectedGroup) => {
        console.log(selectedGroup);
        setSelectedGroup(selectedGroup);
    }




    const handleReportGen = async () => {

        goFullScreen();

        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";

        var reportAPIResponse = {};
        var payload = {};


        if (ReportType == 1) {

            var gp_code = SelectedGroup;

        }

        if (ReportType == 2) {

            var gp_code = 0;
        }
        payload = {

            "div_code": SelectedDiv,

            'gp_code': gp_code,
            "depo_code": SelectedDepo,

        };
        reportAPIResponse = await proxy(`/api/mis/iqvia`, payload, "get", false);





        if (reportAPIResponse.data.length == 0) {
            setreportGenData({ title: "NO DATA", data: [[]] });
        } else {
            setreportGenData(reportAPIResponse);
        }




        setShowOptions(false);
        setShowProcessLoader(false);


    }
    function convertGroupData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                name: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const loadGroupList = async (div, year) => {
        setGroupLoader(true);
        const grouplistAPIResponse = await proxy(`/api/mis/iqviagrouplist/${div}`, {}, "get", true);
        const converted_list = convertGroupData(grouplistAPIResponse);
        setGroupListItems(converted_list);
        setGroupLoader(false);
        setSelectedGroup(converted_list[0].value);
    }



    const handleBranchChange = (branchVal) => {
        setSelectedDepo(branchVal);
    }

    const handleDivChange = (divVal) => {
        setSelectedDIV(divVal);
    }

    useEffect(() => {
        loadGroupList(SelectedDiv, SelectedYear);

        transformNavDataForLabels("NW14").then(title => {
            setPageTitle(title);
        });

    }, []);

    return (<>
        <div className="main-content">
            {showProcessLoader && <ProcessLoader />}
            {showOptions ?
                <ReportOptions title={pageTitle} >

                    <div className="report-option-wrapper">

                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label>Division</label>
                                <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { loadGroupList(newVal, SelectedYear); setSelectedDIV(newVal); }} />
                            </div>

                            <div className="report-option-item ml-20">
                                <label className="mr-16" style={{ marginLeft: "5px" }}>Branch</label>
                                <DropDownControl data={allIndiaTypeDepo} id="report_branch_list" name="report_branch_list"

                                    onChange={handleBranchChange}
                                />
                            </div>

                        </div>





                        <div className="report-option-row">
                            <div className="report-option-item">
                                <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 1)}
                                    onChange={(e) => { setReportType(1); }} />
                                <label>Groupwise</label>
                            </div>
                            <div className="report-option-item ml-10">
                                <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 2)}
                                    onChange={(e) => { setReportType(2); }} />
                                <label>All</label>
                            </div>
                        </div>



                        {ReportType == 1 &&
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Group</label>


                                    {groupLoader ? <BrandedLoader /> :

                                        <DropDownControl data={GroupListItems}

                                            onChange={handleGroupChange}
                                        />



                                    }
                                </div>

                            </div>
                        }


                        <div className="report-option-action-row">
                            <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                        </div>
                    </div>

                </ReportOptions>
                :
                <><div className="row">
                    <div className="col-12">
                        <div className="card report-card" style={{ width: "auto", minWidth: "auto" }}>
                            <div className="card-title report-card-title">{reportGenData.title}
                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                            </div>
                            <div className="card-body">
                                <IQVIADT
                                    tableData={reportGenData}

                                    handleExportSheet={handleExportSheet}

                                    fixedHeader={false}
                                    fixedColumns={true}
                                    forceDecimal={reportGenData.decimal_keys?.length > 0}
                                     decimalKeys={reportGenData.decimal_keys}


                                />

                            </div>
                            <div className="card-footer">


                            </div>
                        </div>
                    </div>
                </div></>
            }
        </div>

    </>);
}

export default NW14;